import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import LoadingSpinner from '../spinner/LoadingSpinner';

import './ConfirmationModalNew.scss';

const ConfirmationModalNew = (props) => {
	const {
		showCancel = true,
		size,
		onCancel,
		backdropClassName,
		title,
		customModalBodyClass,
		showLoadingSpinner,
		children,
		cancelLabel,
		onConfirm,
		confirmLabel,
		className,
		scrollable,
		reverseButtons = false,
		primaryActionDisabled,
		disableBackdrop = false,
		showChildrenWhileLoading = false,
		disableCancel = false
	} = props;

	const cancelButton = (
		<button
			type="button"
			onClick={onCancel}
			className={classNames('button', { 'button-primary': reverseButtons, 'button-secondary': !reverseButtons })}
			disabled={disableCancel}
		>
			{cancelLabel || 'Cancel'}
		</button>
	);

	return (
		<Modal
			size={size || 'md'}
			show
			aria-labelledby="contained-modal-title-vcenter"
			centered
			scrollable={!!scrollable}
			className={classNames('confirmation-modal-new', className)}
			onHide={onCancel}
			backdropClassName={backdropClassName}
			backdrop={disableBackdrop ? 'static' : true}
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">{title || 'Confirm'}</Modal.Title>
			</Modal.Header>
			<Modal.Body className={customModalBodyClass}>
				{!showLoadingSpinner ? (
					children
				) : (
					<div className="spinner-wrapper">
						<LoadingSpinner key="loading-spinner" />
						{showChildrenWhileLoading && children}
					</div>
				)}
			</Modal.Body>
			<Modal.Footer>
				{showCancel && !reverseButtons && cancelButton}
				<button
					type="button"
					className={classNames('button', { 'button-primary': !reverseButtons, 'button-secondary': reverseButtons })}
					onClick={onConfirm}
					disabled={showLoadingSpinner || primaryActionDisabled}
				>
					{confirmLabel || 'Confirm'}
				</button>
				{showCancel && reverseButtons && cancelButton}
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmationModalNew;
